import { TrendingUp, TrendingDown, Minus } from 'lucide-react';

const trendRank: Record<string, number> = { Up: 1, Flat: 2, Down: 3, Insufficient: 4 };

export function trendSortRank(direction: string): number {
  return trendRank[direction] ?? 5;
}

export function TrendIcon({ direction, className = '' }: { direction: string; className?: string }) {
  switch (direction) {
    case 'Up':
      return <TrendingUp className={`h-4 w-4 text-green-600 ${className}`} />;
    case 'Down':
      return <TrendingDown className={`h-4 w-4 text-red-600 ${className}`} />;
    case 'Flat':
      return <Minus className={`h-4 w-4 text-gray-400 ${className}`} />;
    default:
      return null;
  }
}
